import type { Event, StorageData } from '../types';

const STORAGE_KEY = 'dividy_events';
const CURRENT_VERSION = 1;
const MAX_STORAGE_SIZE = 5 * 1024 * 1024; // 5MB limit

export interface StorageResult {
  success: boolean;
  error?: string;
}

export function loadEvents(): Event[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return [];

    const parsed: StorageData = JSON.parse(data);
    // Handle migrations if needed based on version
    return parsed.events;
  } catch (error) {
    console.error('Failed to load events:', error);
    return [];
  }
}

export function saveEvents(events: Event[]): StorageResult {
  try {
    const data: StorageData = {
      version: CURRENT_VERSION,
      events,
    };
    const serialized = JSON.stringify(data);

    // Check storage quota
    if (serialized.length > MAX_STORAGE_SIZE) {
      return {
        success: false,
        error: 'El almacenamiento está lleno. Elimina algunos eventos para continuar.',
      };
    }

    localStorage.setItem(STORAGE_KEY, serialized);
    return { success: true };
  } catch (error) {
    console.error('Failed to save events:', error);

    // Check if it's a quota exceeded error
    if (error instanceof DOMException && error.name === 'QuotaExceededError') {
      return {
        success: false,
        error: 'El almacenamiento está lleno. Elimina algunos eventos para continuar.',
      };
    }

    return {
      success: false,
      error: 'No se pudieron guardar los cambios. Intenta de nuevo.',
    };
  }
}

export function clearAllData(): StorageResult {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return { success: true };
  } catch (error) {
    console.error('Failed to clear data:', error);
    return {
      success: false,
      error: 'No se pudieron eliminar los datos.',
    };
  }
}
